import type { MonitoringNotification } from "./use-notifications";

// Development preview only. Set VITE_MOCK_NOTIFICATIONS=true to opt into mocks; the API is the default.
export const mockNotificationsEnabled =
	import.meta.env.DEV && import.meta.env.VITE_MOCK_NOTIFICATIONS === "true";

const payload: MonitoringNotification["payload"] = {
	kind: "review",
	action: "INCREASE",
	level: "adset",
	metaId: "23851234567890123",
	reasonCode: "SCALE_CANDIDATE",
	metrics: {
		spend: "125.40",
		impressions: "18420",
		clicks: "632",
		ctr: "3.43",
		cpc: "0.20",
		results: "48",
		cpa: "2.61",
		roas: "4.8",
	},
	period: { since: "2026-10-01", until: "2026-10-08" },
	before: "2500",
	after: "3000",
	currency: "USD",
	conversationId: "main",
	reviewId: "mock-review-increase",
};

const items: MonitoringNotification[] = [
	{
		id: "mock-increase",
		monitor_id: "mock-monitor",
		read_at: null,
		created_at: "2026-10-08T09:30:00Z",
		review_id: "mock-review-increase",
		review_status: "open",
		payload: { ...payload },
	},
	{
		id: "mock-pause",
		monitor_id: "mock-monitor",
		read_at: null,
		created_at: "2026-10-08T09:00:00Z",
		review_id: "mock-review-pause",
		review_status: "open",
		payload: {
			...payload,
			action: "PAUSE",
			level: "ad",
			metaId: "23851234567890456",
			reasonCode: "UNDERPERFORMING",
			before: undefined,
			after: undefined,
			metrics: { spend: "87.50", clicks: "24", results: "0", ctr: "0.42" },
			reviewId: "mock-review-pause",
		},
	},
	{
		id: "mock-applied",
		monitor_id: "mock-monitor",
		read_at: "2026-10-08T08:40:00Z",
		created_at: "2026-10-08T08:30:00Z",
		review_id: null,
		review_status: null,
		payload: { ...payload, kind: "applied", reviewId: null },
	},
	{
		id: "mock-access",
		monitor_id: "mock-monitor",
		read_at: null,
		created_at: "2026-10-08T08:00:00Z",
		review_id: null,
		review_status: null,
		payload: {
			...payload,
			kind: "access",
			action: "REVIEW",
			reasonCode: "META_CONNECTION_REQUIRED",
			metrics: {},
			period: undefined,
			before: undefined,
			after: undefined,
			reviewId: null,
		},
	},
];

export function getMockNotifications() {
	return {
		items: structuredClone(items),
		unread: items.filter((item) => !item.read_at).length,
		nextCursor: null,
	};
}

export function getMockNotification(id: string) {
	const item = items.find((item) => item.id === id);
	if (!item) throw new Error("Notification not found");
	return structuredClone(item);
}

export function readMockNotification(id: string) {
	const item = items.find((item) => item.id === id);
	if (item) item.read_at ??= new Date().toISOString();
	return { ok: true as const };
}

export function answerMockReview(
	reviewId: string,
	action: "approve" | "reject",
) {
	const item = items.find((item) => item.review_id === reviewId);
	if (!item) throw new Error("Review not found");
	if (item.review_status !== "open")
		return { status: "already_resolved" as const };
	item.review_status = action === "approve" ? "approved" : "rejected";
	return { status: "resolved" as const };
}
